import React from 'react';
import { useSelector } from 'react-redux';
import { selectUser, selectPendingGoogleDob } from '../../store/authSlice';
import { userNeedsDob } from '../../utils/userNeedsDob';
import DobCollectionModal from './DobCollectionModal';

/**
 * Shows a blocking DOB modal only after Google sign-in when DOB is missing.
 * Saves via PATCH /users/me.
 */
const DobCollectionGate = () => {
  const user = useSelector(selectUser);
  const pendingGoogleDob = useSelector(selectPendingGoogleDob);
  const show = pendingGoogleDob && userNeedsDob(user);

  return <DobCollectionModal show={show} />;
};

export default DobCollectionGate;
